import { actionsKeys, permissionActions } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import { FileChartColumnIncreasing, Split } from "lucide-react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// /api/v1/property-user-associations/grid

const useCostAnalytics = () => {
  const accessPermission = useSelector((state: RootState) => state.currentData.accessPermission);
  const [openCopyDistributionConfig, setOpenCopyDistributionConfig] = useState<boolean>(false);

  const [costAnalyticsCards, setCostAnalyticsCards] = useState([
    {
      id: "distribution-metrics-maintanance",
      title: "Create",
      desc: "Allocation Metrics Maintenance",
      icon: FileChartColumnIncreasing,
      link: `${routes.distributionMetricsMaintenance}`,
      subtitle: "",
      hideCount: true,
      apiKey: "draft",
      module: actionsKeys?.DISTRIBUTION_CONFIG?.toLowerCase(),
      accessKeys: permissionActions.READ,
    },
    {
      id: "distribution-rule-configuration",
      title: "Create",
      desc: "Allocation Rule Configuration",
      icon: Split,
      link: `${routes.distributionRuleConfiguration}`,
      subtitle: "",
      hideCount: true,
      apiKey: "draft",
      module: actionsKeys?.DISTRIBUTION_CONFIG?.toLowerCase(),
      accessKeys: permissionActions.READ,
    },
    {
      id: routes.copyDistributionConfiguration,
      title: "View",
      desc: "Copy Allocation Configuration",
      icon: FileChartColumnIncreasing,
      onClick: () => setOpenCopyDistributionConfig(true),
      subtitle: "",
      hideCount: true,
      apiKey: "",
      module: actionsKeys.DISTRIBUTION_CONFIG?.toLowerCase(),
      accessKeys: permissionActions.UPDATE,
    },
    {
      id: "traceability-report",
      title: "View",
      desc: "Traceability Report",
      icon: FileChartColumnIncreasing,
      link: `${routes.traceability}`,
      subtitle: "",
      hideCount: true,
      apiKey: "",
      module: actionsKeys?.TRACEABILITY_BALANCE?.toLowerCase(),
      accessKeys: permissionActions.READ,
    },
    {
      id: routes.closeout,
      title: "View",
      desc: "Level Closeout Report",
      icon: FileChartColumnIncreasing,
      link: `${routes.closeout}`,
      subtitle: "",
      hideCount: true,
      apiKey: "",
      module: actionsKeys?.CLOSEOUT_BALANCE?.toLowerCase(),
      accessKeys: permissionActions.READ,
    },
    {
      id: routes.costTrialBalance,
      title: "View",
      desc: "Cost Analytics Trial Balance",
      icon: FileChartColumnIncreasing,
      link: `${routes.costTrialBalance}`,
      subtitle: "",
      hideCount: true,
      apiKey: "",
      module: actionsKeys.COST_ANALYTICS_TRIAL_BALANCE?.toLowerCase(),
      accessKeys: permissionActions.READ,
    },
  ]);

  useEffect(() => {
    if (accessPermission) {
      const cards = costAnalyticsCards?.map((card: any) => ({
        ...card, 
        access: !!accessPermission?.[card.module]?.[card.accessKeys],
      }))
      setCostAnalyticsCards(cards);
    }
  }, [accessPermission]);
  
  return {
    costAnalyticsCards,
    openCopyDistributionConfig,
    setOpenCopyDistributionConfig
  };
};

export default useCostAnalytics;
